// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAfakqLKMNP30ZRUBp6SzjM8WRATthLR6I",
  authDomain: "rizzahra-43273.firebaseapp.com",
  projectId: "rizzahra-43273",
  storageBucket: "rizzahra-43273.firebasestorage.app",
  messagingSenderId: "423983546391",
  appId: "1:423983546391:web:6c5612cbaa55fa14f4dc52",
  measurementId: "G-X23F78JT6Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, analytics, db, storage };
